import HTMLDOMParser from './index.js';

export default HTMLDOMParser;



//////////////////
// WEBPACK FOOTER
// ./node_modules/html-dom-parser/index.mjs
// module id = 4007
// module chunks = 11